import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { showConfirmModal } from '../../hooks/useModal';
import { useAuthStore } from '../../stores/useAuthStore';

const ProfileDropdown = () => {
    const navigate = useNavigate();
    const user = useAuthStore((s) => s.user);
    const logoutUser = useAuthStore((s) => s.logoutUser);
    
    const userName: string = (user?.username as string) || (user?.email as string) || (user?.name as string) || "Admin";
    const userFirstName: string = (user?.first_name as string) || ((user?.name as string)?.split(" ")[0] || "");
    const userLastName: string = (user?.last_name as string) || ((user?.name as string)?.split(" ").slice(1).join(" ") || "");

    // Génération des initiales pour l'avatar
    const getInitials = (): string => {
        if (userFirstName && userLastName) {
            return `${userFirstName[0]}${userLastName[0]}`.toUpperCase();
        }
        if (userName) {
            return userName.substring(0, 2).toUpperCase();
        }
        return "U";
    };

    const [isProfileDropdown, setIsProfileDropdown] = useState<boolean>(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const handleLogout = () => {
        showConfirmModal({
            title: "Déconnexion",
            message: "Êtes-vous sûr de vouloir vous déconnecter ? Vous devrez vous reconnecter pour accéder à nouveau à l'application.",
            confirmText: "Oui, me déconnecter",
            cancelText: "Annuler",
            confirmVariant: "warning",
            type: "warning",
            onConfirm: () => {
                logoutUser();
                navigate("/login");
            },
        });
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <span 
                            className="rounded-circle header-profile-user d-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary fw-bold" 
                            style={{ 
                                width: "32px", 
                                height: "32px",
                                fontSize: "0.875rem"
                            }}
                        >
                            {getInitials()}
                        </span>
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem className="p-0">
                        <Link to="/profile" className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profil</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className="p-0">
                        <button
                            type="button"
                            className="dropdown-item"
                            onClick={handleLogout}
                        >
                            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Déconnexion</span>
                        </button>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;